import { ReactNode } from 'react';
import { BoolListLayout } from '../../layouts/bool-list-layout.component';
import type { BasicFormFieldProps, FieldGroupOrientation, InlineLabelPlacement } from '../../layouts/types';
import { CheckListOption } from './checklist-option.component';

type Props = BasicFormFieldProps<'checklist'> & {
  children: ReactNode;
  className?: string;
  label: string;
  labelPlacement?: InlineLabelPlacement;
  labelDisabled?: boolean;
  orientation?: FieldGroupOrientation;
  showLabel?: boolean;
};

export const ChecklistField = ({
  children,
  maxAllowed,
  minRequired,
  showLabel = true,
  orientation = 'vertical',
  ...rest
}: Props) => (
  <BoolListLayout orientation={orientation} showLabel={showLabel} {...rest}>
    {children}
  </BoolListLayout>
);

ChecklistField.Option = CheckListOption;
